import React from "react";
import rightArrow from "../Petunjuk/icon/right.svg";
import leftArrow from "../Petunjuk/icon/left.svg";

const Btnslider = ({ direction, moveSlide }) => {
	return (
		<div>
			<button
				onClick={moveSlide}
				className={direction === "next" ? "btn-slide next" : "btn-slide prev"}
			>
				<img  alt="gambar" src={direction === "next" ? rightArrow : leftArrow} />
			</button>
		</div>
	);
};

export default Btnslider;
